import { onMounted, nextTick } from '#imports'

export function useMenuScroller(scrollAmount = 300): {
  initScroller: (container: HTMLElement) => void;
  setupScrollers: () => void;
} {
  const initScroller = (container: HTMLElement): void => {
    if (!container) return
    if (container.dataset.menuScrollerInitialized === '1') return
    const nav = container.closest('nav')
    if (!nav) return

    const scrollLeftBtn = nav.querySelector('[data-scroll-left]') as HTMLElement
    const scrollRightBtn = nav.querySelector('[data-scroll-right]') as HTMLElement
    if (!scrollLeftBtn || !scrollRightBtn) return
    container.dataset.menuScrollerInitialized = '1'

    const checkScroll = (): void => {
      scrollLeftBtn.classList.toggle('hidden', container.scrollLeft <= 0)
      const hasHorizontalScroll = container.scrollWidth > container.clientWidth
      const isAtEnd = container.scrollLeft >= (container.scrollWidth - container.clientWidth - 1)
      scrollRightBtn.classList.toggle('hidden', !hasHorizontalScroll || isAtEnd)
    }

    const bindEvents = (): void => {
      scrollLeftBtn.addEventListener('click', () => {
        const amount = Math.min(scrollAmount, Math.max(1, container.clientWidth - 1))
        const maxScrollLeft = Math.max(0, container.scrollWidth - container.clientWidth)
        const nextLeft = Math.max(0, container.scrollLeft - amount)
        container.scrollTo({ left: Math.min(nextLeft, maxScrollLeft), behavior: 'smooth' })
      })

      scrollRightBtn.addEventListener('click', () => {
        const amount = Math.min(scrollAmount, Math.max(1, container.clientWidth - 1))
        const maxScrollLeft = Math.max(0, container.scrollWidth - container.clientWidth)
        const nextLeft = Math.min(maxScrollLeft, container.scrollLeft + amount)
        container.scrollTo({ left: nextLeft, behavior: 'smooth' })
      })

      container.addEventListener('scroll', checkScroll)
      window.addEventListener('resize', checkScroll)

      const images = container.querySelectorAll('img')
      for (const img of images) {
        img.addEventListener('load', checkScroll)
      }
    }

    checkScroll()
    bindEvents()
  }

  const setupScrollers = (): void => {
    const containers = document.querySelectorAll<HTMLElement>('[data-menu-scroller]')
    for (const container of containers) {
      initScroller(container)
    }
  }

  onMounted(() => {
    nextTick(() => {
      setupScrollers()
    })
  })

  return {
    initScroller,
    setupScrollers
  }
}